import type {NavigateFunction} from "react-router-dom";

import {userPropertyService} from "@/src/modules/core/services/user-property";
import type {Me} from "@/src/modules/core/types";
import {getNavigationPathBeforePropertyChange} from "@/src/modules/routing/lib/get-navigation-path-before-property-change";
import type {Property} from "@/src/modules/properties/types";

type ApplyDispatchDeskPropertyArgs = {
  property: Property;
  currentProperty: Property | null;
  me: Me;
  pathname: string;
  navigate: NavigateFunction;
};

/** Switch global property context (same navigation rules as the legacy property combobox). */
export function applyDispatchDeskPropertyChange({
  property,
  currentProperty,
  me,
  pathname,
  navigate,
}: ApplyDispatchDeskPropertyArgs) {
  if (currentProperty && String(currentProperty.id) === String(property.id)) {
    return;
  }

  const applyProperty = () => {
    userPropertyService.setUserProperty(property);
  };

  const nextPath = getNavigationPathBeforePropertyChange({
    pathname,
    nextProperty: property,
    isAdmin: Boolean(me.isAdmin),
    isSeniorSupervisor: Boolean(me.isSeniorSupervisor),
  });

  if (nextPath == null) {
    applyProperty();
    return;
  }

  navigate(nextPath, {replace: true});
  window.setTimeout(applyProperty, 0);
}
